/************************************************************
 Patient Namespace
 ************************************************************/

 window.MedicationNS = {
    getViews: function(params, callback){
        Hades.showLoading();

        $.getJSON('/prescription/medication/get_medication_views', params)
            .done(function (data, status, xhr) {
                Hades.hideLoading();

                if(callback){
                    callback(data);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });
    },

    getPrescriptionViews: function (params, callback) {
        Hades.showLoading();

        $.getJSON('/prescription/medication/get_medication_prescription_views', params)
            .done(function (data, status, xhr) {
                Hades.hideLoading();

                if(callback){
                    callback(data);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });
    }
};